import { useEffect } from "react";
import legacyI18n from "@/legacy/i18n";
import { i18n } from "@/shared/i18n";

/**
 * Sincronizzazione i18next -> i18n legacy (il verso opposto lo fa gia' il setter di `legacy/i18n.js`).
 * Il setter legacy ignora la lingua gia' corrente, quindi non c'e' rimbalzo. Sparisce con l'ultima vista legacy.
 * (Non si chiama `LegacyBridge.tsx`: su un filesystem case-insensitive `./LegacyBridge` risolverebbe a `legacyBridge.ts`.)
 */
export function LegacyLanguageBridge() {
  useEffect(() => {
    const sync = (language: string) => {
      legacyI18n.locale = language;
    };
    sync(i18n.language);
    i18n.on("languageChanged", sync);
    return () => {
      i18n.off("languageChanged", sync);
    };
  }, []);
  return null;
}
